<template>
  <q-card
    class="full-height col-md-4 col-12"
    flat
    :style="{
      borderTop: `4px solid ${getColor(color)}`,
      borderRight: `1px solid ${getColor(color)}`,
      borderBottom: `1px solid ${getColor(color)}`,
      borderLeft: `1px solid ${getColor(color)}`,
      boxShadow: shadow ? '0 8px 4px rgba(120, 120, 120, 0.1) !important' : 'none'
    }"
  >
    <q-card-section class="q-px-lg q-pt-lg">
      <div class="flex justify-between items-center">
        <div>
          <div class="text-bold flex" style="font-size: 1.3rem">
            <div class="q-my-auto">
              {{ title }}
            </div>
            <div v-if="isPrimary" class="q-ml-sm q-mb-xs">
              <q-badge
                rounded
                color="accent"
                class="q-px-sm q-py-xs"
                style="font-size: 0.8rem; font-weight: 450"
              >
                Most Popular
              </q-badge>
            </div>
          </div>
          <div v-if="subtitle" :class="[$q.dark.isActive ? 'text-grey-4' : 'text-grey-8']">
            {{ subtitle }}
          </div>
        </div>
        <q-icon :name="icon" size="md" :color="color" class="q-my-auto" />
      </div>
    </q-card-section>
    <q-separator />
    <q-card-section class="q-px-lg">
      <slot></slot>
      <div>
        <slot name="footer" />
      </div>
    </q-card-section>
  </q-card>
</template>

<script lang="ts">
import { colors } from 'quasar'

export default {
  name: 'DashboardCard',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    subtitle: {
      type: String,
      default: undefined
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getColor(color: string) {
      return colors.getPaletteColor(color)
    }
  }
}
</script>
